import type { Messages } from './en'

export const arMessages: Messages = {
  errors: {
    code: {
      not_found: 'تعذر العثور على العنصر المطلوب.',
      unauthorized: 'انتهت جلستك. يرجى تسجيل الدخول مرة أخرى.',
      forbidden: 'ليس لديك إذن لتنفيذ هذا الإجراء.',
      rate_limited: 'طلبات كثيرة جداً. يرجى الانتظار قليلاً والمحاولة مرة أخرى.',
      conflict: 'يتعارض هذا الإجراء مع بيانات موجودة.',
      internal_error: 'حدث خطأ من جانبنا. يرجى المحاولة لاحقاً.',
      validation_error: 'يرجى التحقق من المدخلات والمحاولة مرة أخرى.',
      field_owned_by_hr: 'يتم صيانة هذا الحقل من قبل الموارد البشرية ولا يمكن تغييره هنا.',
      salary_locked_by_pay_run: 'الراتب مقفل أثناء معالجة كشف الرواتب.',
      payroll_identity_locked_for_edit:
        'هوية كشف الرواتب مقفلة. استخدم فتح القفل أعلاه لتعديل بطاقة الموظف.',
      client_not_active_for_assignment:
        'العميل غير نشط بعد. افتح إدارة العملاء، أكمل الإعداد، ثم فعّل العميل قبل تعيين الموظفين.',
      workforce_role_code_exists:
        'رمز الدور مستخدم بالفعل. اختر رمزاً مختلفاً أو استخدم الدور الموجود من القائمة.',
      unknown: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    },
    reference: 'مرجع: {{ref}}',
    boundary: {
      title: 'حدث خطأ ما',
      description: 'حدث خطأ غير متوقع. يمكنك العودة إلى الصفحة الرئيسية والمحاولة مرة أخرى.',
      home: 'الذهاب إلى الرئيسية',
    },
  },
}
